module.exports = __webpack_public_path__ + "static/img/logoN.b9072fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoN.png
// module id = K/hx
// module chunks = 16